/*=========================================================================================
  File Name: moduleActivity.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleTeacherState.js'
import mutations from './moduleTeacherMutations.js'
import actions from './moduleTeacherActions.js'
import getters from './moduleTeacherGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

